/**
 * @file SubmitButtonComponent.tsx
 * @description
 * -----------------------------------------------------
 * Componente de submit button
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-03-03
 * @modified 2025-07-18
 * @author DLTCode
 * @author Ismael Benabdellah
 * @author Nacho Moya
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
import { useFormStatus } from "react-dom";
import ButtonComponent from "@/components/ui/ButtonComponent";
import { ButtonComponentProps, ButtonMessageKey } from "@/types/ui";
export interface SubmitButtonProps {
  buttonLabel: ButtonMessageKey;
  className?: string;
  color?: ButtonComponentProps["color"];
  loading?: boolean;
  disabled?: boolean;
  icon?: ButtonComponentProps["icon"];
  iconProps?: ButtonComponentProps["iconProps"];
  title?: string;
  label?: string;
}
const SubmitButtonComponent = t0 => {
  const $ = _c(10);
  const {
    buttonLabel,
    className,
    color: t1,
    loading,
    disabled,
    icon,
    iconProps,
    title,
    label
  } = t0;
  const color = t1 === undefined ? "primary" : t1;
  const {
    pending
  } = useFormStatus();
  const isLoading = loading || pending;
  let t2;
  if ($[0] !== buttonLabel || $[1] !== className || $[2] !== color || $[3] !== disabled || $[4] !== icon || $[5] !== iconProps || $[6] !== isLoading || $[7] !== label || $[8] !== title) {
    t2 = <ButtonComponent type="submit" color={color} className={className} loading={isLoading} disabled={disabled} title={title} aria-label={label} icon={icon} iconProps={iconProps} label={buttonLabel} />;
    $[0] = buttonLabel;
    $[1] = className;
    $[2] = color;
    $[3] = disabled;
    $[4] = icon;
    $[5] = iconProps;
    $[6] = isLoading;
    $[7] = label;
    $[8] = title;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default SubmitButtonComponent;